import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from 'react-native';
import {
  checkLocationIsValid,
  checkPermitionAndGetPosition,
} from 'src/utils/location';
import { selecetmaptype } from '../selectors/Map';
import { findCity } from '../utils/findCity';

const ONE_DAY_IN_MINUTES = 24 * 60; // 1440 minutes

export const useUserLocationInterval = () => {
  const locationIntervalRef = useRef(null);
  const { userPosition } = useSelector(state => selecetmaptype(state));
  const appState = useRef(AppState.currentState);

  const startLocationInterval = () => {
    locationIntervalRef.current = setInterval(() => {
      
      checkPermitionAndGetPosition({
        timeout: 30000,
        onSuccess: position => {
          findCity({
            latitude: position.coords?.latitude,
            longitude: position.coords?.longitude,
          });
          console.log('Location interval update:', position);
        },
        onError: error => {
          console.log('Location interval error:', error);
        },
      });
    }, 30000); // Update every 30 seconds
  };

  useEffect(() => {
    // Handle app state changes
    const subscription = AppState.addEventListener('change', nextAppState => {
      if (appState.current.match(/inactive|background/) && nextAppState === 'active') {
        // App has come to foreground
        clearInterval(locationIntervalRef.current); // Clear the existing interval
        startLocationInterval(); // Restart the location interval
      }
      appState.current = nextAppState;
    });

    // Initial check and interval start
    const isLocationValid = userPosition?.timestamp
      ? checkLocationIsValid(userPosition.timestamp, ONE_DAY_IN_MINUTES)
      : false;

    if (!isLocationValid) {
      clearInterval(locationIntervalRef.current);
      startLocationInterval();
    }

    return () => {
      // Cleanup when the component is unmounted
      subscription.remove();
      if (locationIntervalRef.current) {
        clearInterval(locationIntervalRef.current);
      }
    };
  }, [userPosition]); // Trigger this effect when userPosition changes

  return null;
};
